var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowSdsPageHeader)?_c('div',{class:{
        'sds-event-details-page-header': !_vm.isMobileLayout,
    }},[_c('SdsPageHeader',{attrs:{"name":_vm.name,"breadcrumbs":_vm.breadcrumbs,"actionsBreadcrumbs":_vm.actionItems,"hasUnderline":false,"shouldShowPageName":false}}),_c('EventDetailsPageHeader')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }